import {
    IonHeader,
    IonLabel,
    IonSegment,
    IonSegmentButton,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

interface _Props {
    active: string
    onSelect: Function
}

const AlertsChoiceMenu: React.FC<_Props> = ({active, onSelect}) => {
    const [currentActiveBtn, setCurrentActiveBtn] = useState(active || "all");

    useEffect(() => {
        setCurrentActiveBtn(active);
    }, [active]);

    const handleSelection = async (selection: string) => {
        await setCurrentActiveBtn(selection);
        onSelect(selection);
    }

    return (
        <IonHeader id="alertChoiceMenu">
            <IonSegment color="primary" mode="ios" value={currentActiveBtn || active} scrollable={true} onIonChange={e => {handleSelection(e.detail.value || "all");}}>
                <IonSegmentButton value="all">
                    <IonLabel>Get All Alerts</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="filter">
                    <IonLabel>Filter</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="stop">
                    <IonLabel>Stop Alerts</IonLabel>
                </IonSegmentButton>
            </IonSegment>
        </IonHeader>
    );
};

export default AlertsChoiceMenu;
